import React from 'react';
import './Countdown.scss';
import { secondsToClock } from '../../../utils/dates/date-utility';

require('animate.css/animate.min.css');

const applyClassNames = (className, isWarningPeriod) => {
  const classes = ['countdown', 'time-remaining'];
  if (isWarningPeriod) {
    classes.push('animated');
    classes.push('flash');
    classes.push('red');
  }
  if (className) {
    classes.push(className);
  }
  return classes.join(' ');
};

const Countdown = ({ className, currentTime, isWarningPeriod }) => (
  <div className={applyClassNames(className, isWarningPeriod)}>
    Time Remaining: {secondsToClock(currentTime)}
  </div>
);

export default Countdown;
